var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShow)?_c('span',{staticClass:"price-base"},[_vm._v("("+_vm._s(_vm._f("price")(_vm.basePrice))+"/"),(_vm.product.baseprice_reference_amount > 1)?_c('span',[_vm._v(_vm._s(_vm.product.baseprice_reference_amount))]):_vm._e(),_vm._v(_vm._s(_vm.basePriceUnit(_vm.product.baseprice_reference_unit))+")")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }